module.exports = __webpack_public_path__ + "img/destination-5.e6b69890.svg";